import React from 'react'
import { PaymentElement, LinkAuthenticationElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { useState, useEffect } from 'react'
import api from '../api/api'

const CheckoutForm = ({ orderNumber, sellerId, sellerName }) => {
    localStorage.setItem('orderNumber', orderNumber)
    const stripe = useStripe()
    const elements = useElements()
    const [message, setMessage] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [clientUrl, setClientUrl] = useState(window.location.origin)

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                // Use sellerId for API, but sellerName for URLs
                if (!sellerId) {
                    console.error('Seller ID not found');
                    return;
                }
                // Fetch seller's payment configuration (public endpoint)
                const { data } = await api.get(`/seller/${sellerId}/payment-config/public`);
                if (data.success && data.config.clientUrl) {
                    setClientUrl(data.config.clientUrl);
                }
            } catch (error) {
                console.error('Error fetching config:', error);
                // Use default client URL if fetch fails
                setClientUrl('http://localhost:3000');
            }
        };
        fetchConfig();
    }, [sellerId]);

    const paymentElementOptions = {
        loyout: 'tabs'
    }

    const submit = async (e) => {
        e.preventDefault()

        if (!stripe || !elements) {
            return
        }

        setIsLoading(true)
        // Use sellerName for return_url
        const sellerNameForUrl = sellerName;
        
        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${clientUrl}/${sellerNameForUrl}/order/confirm`
            }
        })
        if (error.type === 'card_error' || error.type === 'validation_error') {
            setMessage(error.message)
        } else {
            setMessage('An unexpected error occurred')
        }
        setIsLoading(false)
    }

    return (
        <form onSubmit={submit} id='payment-form' >
            <LinkAuthenticationElement
                id='link-authentication-element'
            />
            <PaymentElement id='payment-element' options={paymentElementOptions} />
            <button disabled={isLoading || !stripe || !elements} id='submit' className='px-10 py-[6px] rounded-sm hover:shadow-orange-500/20 hover:shadow-lg bg-orange-500 text-white'>
                <span id='button-text'>
                    {
                        isLoading ? <div>Loading.....</div> : "Pay now"
                    }
                </span>
            </button>
            {message && <div>{message}</div>}
        </form>
    )
}

export default CheckoutForm